import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '統計で見る！新潟県日本一 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="統計で見る！新潟県日本一" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2023夏号 No.163 目次",
              path: "/no163"
            },
            {
              name: "統計で見る！新潟県日本一"
            }
          ]}
        />
        <img
          src={`${basePath}/no163/img/4-12.png`}
          alt="イラスト"
          css={style.img(250)}
        />
        
        <h4 css={style.subTitle02}>むし歯の本数（12歳児1人当たり） 0.2本 日本一少ない!</h4>
        <p>12歳児のむし歯本数の全国平均は、1人あたり0.63本で、新潟県は0.2本。なんと20年以上連続日本一となっています。また、小学6年～高校3年までのすべての学年でむし歯がある児童・生徒の割合が全国で最も低い結果となっています。</p>
        <p css={style.notetTxt}>出典：文部科学省総合教育政策局「学校保健統計調査」令和3年度</p>
        <BackBtn href={"/no163"} />
      </Content>
    </Page>
  )
}
export default Home
